import { handleSubmit } from "../form";

const submit = crm => info => handleSubmit({ crm, ...info });

export default submit;
